import React from 'react';
import PropTypes from 'prop-types';
import {AssigneeGroupWrapper, Hexagon, Image, AssigneeWrapper, AssigneeGroupText} from './AssigneeGroup.styled';
import {HexagonCount} from './HexagoneCount';
import {TextUtils} from '../../utils/text_utils';
import {Count} from './Count';

export const AssigneeGroup = ({showCount, showSingleName, assignees, alignStart, iconSpaceBetween, hideCountFrame}) => {
	if (assignees.length === 0) {
		return <div></div>;
	}

	const isLastElement = index => {
		return index === assignees.length - 1;
	};

	// only want a counter for the assignees if counter shows 2 or more,
	// if 1, we can just show the image,
	const getShowCount = () => (assignees.length > showCount ? showCount - 1 : assignees.length);

	const getRemainingNames = () => {
		let names = '';
		assignees.forEach((assignee, index) => {
			if (index >= showCount - 1) names += assignee.fullName + (!isLastElement(index) ? ' ; ' : '');
		});
		return names;
	};

	return (
		<AssigneeGroupWrapper alignStart={alignStart}>
			{assignees.slice(0, getShowCount()).map((assignee, index) => {
				return (
					<AssigneeWrapper
						key={index}
						iconSpaceBetween={iconSpaceBetween}
						useMargin={!isLastElement(index)}
						title={assignee.fullName}
					>
						{assignee.imageSource ? (
							<Image crossOrigin="use-credentials" src={assignee.imageSource} />
						) : (
							<Hexagon type={'initials'} className="SMALL">
								{TextUtils.getInitials(assignee.fullName)}
							</Hexagon>
						)}
					</AssigneeWrapper>
				);
			})}
			{showSingleName && assignees.length === 1 && <AssigneeGroupText>{assignees[0].fullName}</AssigneeGroupText>}
			{assignees.length > showCount &&
				(hideCountFrame ? (
					<Count number={assignees.length - showCount + 1} remainingNames={getRemainingNames()} />
				) : (
					<HexagonCount number={assignees.length - showCount + 1} remainingNames={getRemainingNames()} />
				))}
		</AssigneeGroupWrapper>
	);
};

AssigneeGroup.propTypes = {
	showCount: PropTypes.number,
	// Toggle whether or not to show the full name along with the icon if only one element is selected
	showSingleName: PropTypes.bool,
	assignees: PropTypes.arrayOf(
		PropTypes.shape({
			fullName: PropTypes.string.isRequired,
			imageSource: PropTypes.string,
		})
	),
	alignStart: PropTypes.bool,
	// Margin between assignee icons
	iconSpaceBetween: PropTypes.number,
	compact: PropTypes.bool,
	hideCountFrame: PropTypes.bool,
};
